import React from 'react';
import './FooterSection.css';
// Import icons from a library like react-icons or use local SVGs
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';

const FooterSection = () => {
  const timings = [
    { day: "Monday", time: "09am-05pm" },
    { day: "Tuesday", time: "09am-05pm" },
    { day: "Wednesday", time: "09am-05pm" },
    { day: "Thursday", time: "09am-05pm" },
    { day: "Friday", time: "09am-05pm" },
    { day: "Saturday", time: "09am-05pm" },
    { day: "Sunday", time: "Closed" },
  ];

  return (
    <footer className="footer-container">
      <div className="footer-content">
        {/* Column 1: Profile & Contact */}
        <div className="footer-column profile-col">
          <div className="logo-area">
             {/* Replace with actual logo image */}
            <h2 className="brand-name">Dr. Garlapati Siva Srikar</h2>
            <p className="brand-sub">Consultant Orthopedic Surgeon.</p>
          </div>
          <p className="bio">
            Dr. Garlapati Siva Srikar is a Consultant Orthopedic Surgeon specializing in Trauma, Joint Replacement, Arthroscopy, and Sports Medicine.
          </p>
          
          <div className="contact-info">
            <div className="contact-item">
              <FaMapMarkerAlt className="icon" />
              <div>
                <strong>Sri Lakshmi Nilayam Apartments,</strong>
                <p>2nd line, SVN colony, Guntur...</p>
              </div>
            </div>
            <div className="contact-item">
              <FaMapMarkerAlt className="icon" />
              <p>Flat no 103, Sri Lakshmi Nilayam Apartments ...</p>
            </div>
            <div className="contact-item">
              <FaPhoneAlt className="icon" />
              <p>+91 7382513158</p>
            </div>
            <div className="contact-item">
              <FaEnvelope className="icon" />
              <p>sivasrikar.garlapati@gmail.com</p>
            </div>
          </div>
        </div>

        {/* Column 2: Our Services */}
        <div className="footer-column">
          <h3>Our Services</h3>
          <ul className="services-list">
            <li>Total Knee Replacement Surgery (Robotic)</li>
            <li>Total Hip Replacement Surgery (Robotic)</li>
            <li>Shoulder Pain Treatment</li>
            <li>Arthroscopic Surgeries</li>
            <li>Sports Medicine</li>
            <li>ACL Reconstruction Surgery</li>
            <li>Trauma</li>
          </ul>
        </div>

        {/* Column 3: Our Timings */}
        <div className="footer-column">
          <h3>Our Timings</h3>
          <div className="timings-list">
            {timings.map((item, index) => (
              <div key={index} className="timing-row">
                <span>{item.day}</span>
                <span>{item.time}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
